/**
 * blog post filtering
 *
 */
;(function (pyatt, $, window, document, undefined) {

    pyatt.blogFilter = {

        $blog_container : '',

        $blog_grid : '',

        $blog_filter : '',

        $post_list : '',

        $post_box : '',

        //add flag for page loaded
        pageLoaded : false,

        init : function() {

            $('.filter-icon').on( 'click', this.toggleBlogFilter );

            // Set vars
            var $el;
            $blog_container = $('.blog');
            $blog_grid = $blog_container.find('.iso-container');
            $blog_filter = $blog_container.find('#blog-filter');
            //add handler to post list articles
            $post_list = $('#post-list');
            $post_box = $('#post-box');

            // Add data-filters to category links
            // $blog_filter.find('a').not('.show-all').each(this.setIsoDataFilters);

            // Add filter links click handler
            // $blog_filter.on('click', 'a', this.filterClickHandler);
            
            //$('.project-meta').on('click', 'a', this.filterItems);

            // // Init isotope
            // $blog_grid.isotope({
            //     // options
            //     itemSelector: '.post',
            //     layoutMode: 'vertical'
            // });

            // Foundation.utils.image_loaded($blog_grid.find('img'), function(){
            //     console.log('Image Loaded! :)');
            //     // Init isotope
            //     $blog_grid.isotope({
            //         // options
            //         itemSelector: '.post',
            //         gutter: 20,
            //         layoutMode: 'fitRows'
            //     });
            // });

            //add handler for post list clicks
            //$post_list.on('click', '.wrap-link', this.postClickHandler);

            //disable post-cat links for desktop
            // $('.post-categories').on('click', 'a', this.postCatClickHandler);

            //ajax navigation
            // window.addEventListener('popstate', this.ajaxNavigation);

            // if URL is a project-tag archive show filtered grid
            // if (/category/.test(window.location.href)) {
            //     // Get filter link element
            //     $el = pyatt.blogFilter.getFilterLinkfromURL();
            //     // Get filter value
            //     filterValue = pyatt.blogFilter.getFilterValue($el);
            //     // Get id of first cat post
            //     post_id = $post_list.find(filterValue).first().attr('id').substring(5);
            //     //get first post id of newly added set
            //     pyatt.ajaxPost(post_id);
            //     // Filter Items on page with isotope
            //     pyatt.blogFilter.filterItems($el);
            // }
        },

        /**
         *
         * Toggle blog filter dropdown
         *
         */
         toggleBlogFilter : function(e) {
            e.preventDefault();
            var $parent_el = $(this).closest('.filter-container');
            var $dropdown = $parent_el.find('.filter');
            if ( $parent_el.hasClass('-closed') ) {
                $parent_el.removeClass('-closed')
               // $dropdown.slideDown(500);
            } else  {
                $parent_el.addClass('-closed');
                //$dropdown.slideUp(500);   
            }
        },

        /**
         * Add isotope data-filters to tile anchors.
         *
         * Pulls category from end of link slug to use as variable.
         *
         */
        setIsoDataFilters : function() {
            //get href
            var $this = $(this),
                url = $this.attr("href");
            //remove "/" from end of href
            url = url.substring(0, url.length - 1);
            //extract category slug
            var catSlug = url.substring(url.lastIndexOf("/") + 1);
            //add slug as attr
            $this.attr("data-filter", ".category-"+catSlug);
        },


        /**
         * Add isotope data-filters to tile anchors.
         *
         * Pulls category from end of link slug to use as variable.
         *
         */
        filterClickHandler : function(event) {

            var $self = $(this),
                filterValue = pyatt.blogFilter.getFilterValue($self),
                post_id = $('#post-list').find(filterValue).first().attr('id').substring(5);

            //update body classes
            pyatt.updateBodyClasses('blog');
            // Update URL
            pyatt.blogFilter.updateUrl($self);
            //get first post id of newly added set
            pyatt.ajaxPost(post_id);
            // Filter Items on page with isotope
            pyatt.blogFilter.filterItems($self);
            //don't do default click
            event.preventDefault();
        },


        /**
         * Handler for processing post link clicks
         *
         * @param e
         */
        postClickHandler : function(e) {
            console.log('postClickHandler Start');

            ////vars
            var $self = $(this),
                post_id = $self.find('article').attr('id').substring(5),
                catHref = $('#blog-filter').find('.active').attr("href"),
                urlChunks = catHref.split('/'),
                cat = (urlChunks[urlChunks.length - 2]),
                _href = $self.attr("href"),

                stateObj = {
                    navType: 'post',
                    post_id: post_id,
                    cat: cat
                };

            //update post content
            pyatt.ajaxPost(post_id);

            //update body classes
            pyatt.updateBodyClasses('post');

            //update browser url
            pyatt.util.urlChange(stateObj, null, _href);

            e.preventDefault();
            console.log('postClickHandler End');
        },


        /*
         * Filter items on category button click
         *
         */
        filterItems : function($self) {
            console.log('filterItems');

            var filterValue = pyatt.blogFilter.getFilterValue($self);

            //change classes for active category link
            pyatt.blogFilter.setActiveState($self);
            // Run Isotope filter
            $blog_grid.isotope({ filter: filterValue });
         },


        //set active filter link
        setActiveState : function ($self) {
            //remove current active classes
            $blog_filter.find('.active').removeClass('active');
            //add active class to new link
            $self.addClass('active');
        },


        //get filter value from data-attr
        getFilterValue : function($self) {
            console.log('getFilterValue Start');

            var filterValue = $self.attr('data-filter');

            // set all items option
            if (filterValue == '*') {
                filterValue = '.post';
            }
            console.log(filterValue);
            return filterValue;
        },


        // Update Tag URL
        updateUrl : function($self) {
            //vars
            var _href = $self.attr("href"),
                urlChunks = _href.split('/'),
                cat = (urlChunks[urlChunks.length - 2]),
                stateObj = {
                    navType: 'post-cat',
                    cat: cat
                };

            //update browser url
            pyatt.util.urlChange(stateObj, null, _href);
        },

        /**
         * Navigate through blog posts with popstate
         *
         */
        ajaxNavigation : function(event) {
            console.log('navigated');

            var $el = pyatt.blogFilter.getFilterLinkfromURL(),
                url = window.location.href;

            if (pyatt.blogFilter.pageLoaded) {
                //return false;
            }

            pyatt.blogFilter.pageLoaded = true;
            console.log('page-loaded');

            if (event.state) {
                console.log(event.state);

                if (event.state.navType === 'post-cat') {
                    // Get filter anchor from event.state
                    var $el = $blog_filter.find('a[href*=' + event.state.cat + ']'),
                        post_id = $('#post-list').find(".category-"+event.state.cat).first().attr('id').substring(5);

                    // Get first post of cat
                    pyatt.ajaxPost(post_id);
                    // Filter by cat
                    pyatt.blogFilter.filterItems($el);

                } else if (event.state.navType === 'post') {
                    pyatt.ajaxPost(event.state.post_id);
                    // Get filter anchor from event.state
                    $el = $blog_filter.find('a[href*=' + event.state.cat + ']');
                    pyatt.blogFilter.filterItems($el);
                }

            // if URL is a cat archive show filtered grid
            } else if (/latest/.test(url) || /category/.test(url)) {
                // Filter grid by tag in URL
                pyatt.blogFilter.filterItems($el);
            }
        },


        filterAnimate : function($el) {
            // Scroll down to grid
            //pyatt.portfolioGrid.scrollToFilter();
            // Filter grid by tag in URL
            //setTimeout( function() {
                pyatt.blogFilter.filterItems($el);
           // }, 350);
        },


        //scrollToFilter : function() {
        //    var offset = $blog_filter.offset();
        //    $('html,body').animate({scrollTop: offset.top}, 700);
        //},

        getFilterLinkfromURL : function() {
            var urlChunks = window.location.href.split('/'),
                tag = (urlChunks[urlChunks.length - 2]);

            return $blog_filter.find('a[href*='+tag+']');
        },


        /**
         * Disable post cat links on desktop
         *
         * @param e
         */
        postCatClickHandler : function (e) {
            //disable if not on mobile
            if ($(window).width() > 603) {
                //don't go to link
                e.preventDefault();
            }
        }
    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
